var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.3201,
    y: 20.16,
    width: 13.44,
    height: 2.88,
    rx: 1.44,
    transform: "rotate(-180 16.3201 20.16)",
    fill: "#8276F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.4399,
    y: 13.44,
    width: 10.56,
    height: 2.88,
    rx: 1.44,
    transform: "rotate(-180 13.4399 13.44)",
    fill: "#8276F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 20.1599,
    y: 6.71997,
    width: 17.28,
    height: 2.88,
    rx: 1.44,
    transform: "rotate(-180 20.1599 6.71997)",
    fill: "#8276F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.5c83e8179c8359dc384746d25e1dcf65.svg";
export { ForwardRef as ReactComponent };